<div class="modal-header">
	<h4 class="modal-title">Submit form</h4>
	<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
		<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="" transform="translate(-809.000000, -277.000000)" fill="#FFFFFF">
					<g id="" transform="translate(817.202796, 285.202796) rotate(-315.000000) translate(-817.202796, -285.202796) translate(806.702796, 274.202796)">
						<rect id="Rectangle-Copy" transform="translate(10.500000, 11.000000) rotate(-90.000000) translate(-10.500000, -11.000000) " x="-1.36424205e-12" y="10" width="21" height="2" rx="1"></rect>
						<rect id="Rectangle-Copy" transform="translate(10.500000, 11.000000) rotate(-360.000000) translate(-10.500000, -11.000000) " x="-1.36424205e-12" y="10" width="21" height="2" rx="1"></rect>
					</g>
				</g>
			</g>
		</svg>
	</button>
</div>
<div class="modal-body">
	<div class="modal-contents" *ngIf="form_data != ''">
		<div class="form_data" [innerHtml]="form_data | safe:'preamble'"></div>
	</div>
</div>